import * as actions from './actions';

export default function(state = null, action) {
  switch (action.type) {

  case actions.SET_PLAYBOOK_TYPE:
    return action.playbookType;

  default:
    return state;
  }
}
